import { useSystemConfigStore } from "@/stores/systemConfig";

// 获取图片
export function getImage(path: string) {
  return new URL(path, import.meta.url).href;
}

/** 直接获取 app config 指定 key 的值 */
export function getConfig(md: string) {
  // if (md == "mainbiz") {
  //   return "http://192.168.101.192:9888/aa-mainbiz/aa-mainbiz-api/";
  // }
  // if (md == "sso") {
  //   return "http://192.168.101.192:9888/aa-sso/aa-sso-api/";
  // }
  const systemStore = useSystemConfigStore();
  let configInfo = systemStore.getBaseConfig;
  let configInfoCase = configInfo.find((item: any) => item.configKey == md) || {
    configValue: "",
  };
  return configInfoCase.configValue;
}

/** 获取 app config 指定配置 */
export function getInfoKey(data: string) {
  const systemStore = useSystemConfigStore();
  let baseURL = systemStore.getBaseConfig;
  return baseURL.filter((item: any) => item.configKey == data) || [];
}

/** url合法性校验 */
export function urlRegex(url: string) {
  const regex = /^https?:\/\/.*?\/(.*)$/;
  const match = url.match(regex);

  let thirdSegment = "";
  if (match) {
    return (thirdSegment = "/" + match[1]);
  } else {
    return "";
  }
}

/**
 * 过滤数值显示
 * @param {*} num 数值
 * @param {*} type 类型 num 为数字计量 date 为时间计量 ratio 为比例显示为百分比
 * @returns
 */
export function filterNum(num: number, type: "num" | "date" | "ratio" = "num") {
  let objFun = {
    // 数字转换
    num: () => {
      if (String(num) == "null") {
        return "-";
      }
      if (!num) {
        return 0;
      }
      let t1 = "";
      let unit1 = "";
      if (num < 1000) {
        t1 = num.toString();
      } else if (num >= 1000 && num < 1000000) {
        t1 = (num / 1000).toFixed(1);
        unit1 = "K";
      } else if (num >= 1000000 && num < 1000000000) {
        t1 = (num / 1000000).toFixed(1);
        unit1 = "M";
      } else if (num >= 1000000000 && num < 1000000000000) {
        t1 = (num / 1000000000).toFixed(1);
        unit1 = "B";
      }

      // 过滤.0的情况
      if (t1.endsWith(".0")) {
        t1 = t1.replace(".0", "");
      }
      return t1 + unit1;
    },
    // 时间
    date: () => {
      let t2 = 0;
      let unit2 = "";
      let num2 = Number(num) / 1000;
      if (num2 < 60) {
        t2 = num2;
        unit2 = "S";
      } else if (num2 < 60 * 60) {
        t2 = num2 / 60;
        unit2 = "Mins";
      }

      return t2 + unit2;
    },
    // 比例
    ratio: () => {
      return Number(num) * 100 + "%";
    },
  };

  return objFun[type]();
}
/**
 * oss 文件上传
 * @param {*} file
 * @returns
 */
export function OSSFileUpload(file, fileName = "") {
  return new Promise(async (resolve, reject) => {
    let accessKeyId = getConfig("oss_access_key");
    let accessKeySecret = getConfig("oss_access_key_secret");
    let endPoint = getConfig("end_point");
    let bucketName = getConfig("bucket_name");
    const client = new OSS({
      region: "oss-cn-qingdao",
      accessKeyId: accessKeyId,
      accessKeySecret: accessKeySecret,
      endpoint: endPoint,
      bucket: bucketName,
      timeout: 180000,
    });

    try {
      fileName = fileName || Math.random().toString(32).slice(2, 32);
      let name = file.file.name.split(".")[1];
      const { url } = await client.put(`${fileName}.${name}`, file.file);
      resolve(url);
    } catch (e) {
      reject(e);
    }
  });
}
// 获取名字首字母作为头像显示
export function getInitials(name) {
  return name ? name.charAt(0).toUpperCase() : "";
}

/**将 Base64 转换为 File 对象 */
export function base64ToFile(base64String, filename = "file") {
  const arr = base64String.split(",");
  const mimeMatch = arr[0].match(/:(.*?);/);
  const mime = mimeMatch ? mimeMatch[1] : "image/png";
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
}

/**
 * 计算表格宽度
 * @param {*} remValue
 * @param {*} type
 * @returns
 */
export function tableWidth(remValue, type = 1) {
  const rem = (
    remValue *
    parseFloat(getComputedStyle(document.documentElement).fontSize || 16)
  ).toFixed(2);
  return type === 1 ? `${rem}px` : rem;
}
